























import { createComponent } from "@vue/composition-api";
import { formField } from "./form/FormField";
import { StringField } from "./form/InputFields";
import { RevisionItem } from "@megarax/client/src/resources/RevisionItem";
import { formValidator } from "@/shared/formValidator";
import { Resource } from "@megarax/client/src";
import { RevisionActions } from "@megarax/client/src/revision";

interface Props {
  resource: Resource<RevisionActions>;
  value: RevisionItem;
  rules: object;
}

export default createComponent<Props>({
  components: {},
  props: {
    resource: { required: true },
    value: { required: true },
    rules: { default: () => ({}) },
  },
  setup(props, ctx) {
    return { ...formValidator() };
  },
});
